<template>
    <div class="message-view">
        <!--    <b-col class="text-right">
                    <b-btn class="btn btn-ghost-blue mr-1" @click="refresh()">Refresh</b-btn><br>
                </b-col> -->
        <br>
        <b-tabs pills vertical class="py-3">
            <!-- Inbox Tab -->
            <b-tab>
                <template v-slot:title>
                    <b-icon-mailbox/>
                    Inbox
                </template>
                <data-table ref="inboxTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getInbox"
                            v-model="inboxFilters"
                            :fields="inboxFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'fromUser'">
                            <user-details :user="slotProps.row.item.fromUser"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'sent'">
                            <timestamp :date="slotProps.row.item.sent"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'body'">
                            <span>{{ truncate(slotProps.row.item.body) }}</span>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="viewMessage(slotProps.row.item)">
                                <b-icon-eye/>
                            </button>
                            <button class="btn btn-danger btn-sm mr-2 btn-icon"
                                    @click="deleteMessage(slotProps.row.item)">
                                <b-icon-trash/>
                            </button>
                        </div>
                    </template>
                </data-table>
            </b-tab>

            <!-- Sent Tab -->
            <b-tab>
                <template v-slot:title>
                    <b-icon-envelope-open/>
                    Sent
                </template>
                <data-table ref="sentTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getSent"
                            v-model="sentFilters"
                            :fields="sentFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'toUser'">
                            <user-details :user="slotProps.row.item.toUser"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'sent'">
                            <timestamp :date="slotProps.row.item.sent"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'body'">
                            <span>{{ truncate(slotProps.row.item.body) }}</span>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="viewMessage(slotProps.row.item)">
                                <b-icon-eye/>
                            </button>
                        </div>
                    </template>
                </data-table>
            </b-tab>

            <!-- Drafts Tab -->
            <b-tab>
                <template v-slot:title>
                    <b-icon-file-earmark/>
                    Drafts
                </template>
                <data-table ref="draftsTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getDrafts"
                            v-model="draftsFilters"
                            :fields="draftsFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'toUser'">
                            <user-details :user="slotProps.row.item.toUser"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'created'">
                            <timestamp :date="slotProps.row.item.created"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'body'">
                            <span>{{ truncate(slotProps.row.item.body) }}</span>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="viewMessage(slotProps.row.item)">
                                <b-icon-eye/>
                            </button>
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="openDraft(slotProps.row.item)">
                                <b-icon-pencil-square/>
                            </button>
                            <button class="btn btn-danger btn-sm mr-2 btn-icon"
                                    @click="deleteDraft(slotProps.row.item)">
                                <b-icon-trash/>
                            </button>
                        </div>
                    </template>
                </data-table>
            </b-tab>

            <!-- Trash Tab -->
            <b-tab>
                <template v-slot:title>
                    <b-icon-trash/>
                    Trash
                </template>
                <data-table ref="trashTable"
                            :defaultItemsPerPage="10"
                            :show-filters="true"
                            :show-pager="true"
                            :get-items="getTrash"
                            v-model="trashFilters"
                            :fields="trashFields">
                    <template v-slot:customField="slotProps">
                        <div v-if="slotProps.row.field.key === 'fromUser'">
                            <user-details :user="slotProps.row.item.fromUser"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'sent'">
                            <timestamp :date="slotProps.row.item.sent"/>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'body'">
                            <span>{{ truncate(slotProps.row.item.body) }}</span>
                        </div>
                        <div v-else-if="slotProps.row.field.key === 'actions'">
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="restoreTrash(slotProps.row.item)">
                                <b-icon-inbox/>
                            </button>
                            <button class="btn btn-secondary btn-sm mr-2 btn-icon"
                                    @click="viewMessage(slotProps.row.item)">
                                <b-icon-eye/>
                            </button>
                        </div>
                    </template>
                </data-table>
            </b-tab>
        </b-tabs>

        <message-view-modal :message="message"
                            modalId="viewMessageModal"/>
        <message-create-modal :draft="draft"
                              modalId="messageDraftModal"
                              :recipient="draft.toUser"/>
    </div>
</template>

<script>
import Vue from 'vue'
import UserDetails from '../components/UserDetails'
import MessageCreateModal from '../components/MessageCreateModal'

export default Vue.extend({
    name: 'MessageView',
    components: { MessageCreateModal, UserDetails },
    data () {
        return {
            inboxFields: [
                { key: 'fromUser', sortable: true, label: 'From' },
                { key: 'subject', sortable: true, label: 'Subject' },
                { key: 'body', label: 'Message' },
                { key: 'sent', sortable: true, label: 'Received' },
                { key: 'status', sortable: true, label: 'Read' },
                { key: 'actions' }
            ],
            sentFields: [
                { key: 'toUser', sortable: true, label: 'To' },
                { key: 'subject', sortable: true, label: 'Subject' },
                { key: 'body', label: 'Message' },
                { key: 'sent', sortable: true, label: 'Sent' },
                { key: 'actions' }
            ],
            draftsFields: [
                { key: 'toUser', sortable: true, label: 'To' },
                { key: 'subject', sortable: true, label: 'Subject' },
                { key: 'body', label: 'Message' },
                { key: 'created', sortable: true, label: 'Created' },
                { key: 'actions' }
            ],
            trashFields: [
                { key: 'fromUser', sortable: true, label: 'From' },
                { key: 'subject', sortable: true, label: 'Subject' },
                { key: 'body', label: 'Message' },
                { key: 'sent', sortable: true, label: 'Received' },
                { key: 'actions' }
            ],
            message: {},
            draft: {},
            inboxFilters: {
                inboxForId: { field: 'inboxForId', type: 'hidden', value: this.$user.userId() },
                fromUser: { field: 'fromUser', type: 'string', value: null, label: 'From' },
                subject: { field: 'subject', type: 'string', value: null, label: 'Subject' },
            },
            sentFilters: {
                sentForId: { field: 'sentForId', type: 'hidden', value: this.$user.userId() },
                toUser: { field: 'toUser', type: 'string', value: null, label: 'To' },
                subject: { field: 'subject', type: 'string', value: null, label: 'Subject' },
            },
            draftsFilters: {
                draftsForId: { field: 'draftsForId', type: 'hidden', value: this.$user.userId() },
                toUser: { field: 'toUser', type: 'string', value: null, label: 'To' },
                subject: { field: 'subject', type: 'string', value: null, label: 'Subject' },
            },
            trashFilters: {
                trashForId: { field: 'trashForId', type: 'hidden', value: this.$user.userId() },
                fromUser: { field: 'fromUser', type: 'string', value: null, label: 'From' },
                subject: { field: 'subject', type: 'string', value: null, label: 'Subject' },
            },
        }
    },
    methods: {
        async getInbox (sort) {
            return await this.$api.getItems(this, 'message', this.inboxFilters, sort, ['fromUser'])
        },
        async getSent (sort) {
            return await this.$api.getItems(this, 'message', this.sentFilters, sort, ['toUser'])
        },
        async getDrafts (sort) {
            return await this.$api.getItems(this, 'message', this.draftsFilters, sort, ['toUser'])
        },
        async getTrash (sort) {
            return await this.$api.getItems(this, 'message', this.trashFilters, sort, ['fromUser'])
        },
        async viewMessage (message) {
            this.$bvModal.show('viewMessageModal')
            this.message = message
            if (message.status === 'UNREAD' && message.to_id === this.$store.state.currentUser.id) {
                message.status = 'READ'
                await this.$api.updateItem(this, 'message', message)
                this.refresh()
            }
        },
        truncate (str, length = 32, end = '...') {
            return str.length > length ? str.substring(0, length - end.length) + end : str
        },
        openDraft (message) {
            this.$bvModal.show('messageDraftModal')
            this.draft = message
        },
        deleteMessage: async function (message) {
            this.$bvModal.msgBoxConfirm('Are you sure you would like to delete this message?')
                .then(async value => {
                    if (value) {
                        message.status = 'HIDDEN'
                        await this.$api.updateItem(this, 'message', message)
                        this.$refs.inboxTable.refresh()
                        this.$refs.trashTable.refresh()
                    }
                })

        },
        deleteDraft: async function (message) {
            this.$bvModal.msgBoxConfirm('Are you sure you would like to delete this draft? Deleted drafts cannot be recovered.')
                .then(async value => {
                    if (value) {
                        await this.$api.deleteItem(this, 'message', message)
                        this.$refs.draftsTable.refresh()
                    }
                })
        },
        restoreTrash: async function (message) {
            this.$bvModal.msgBoxConfirm('Would you like to restore this message to your inbox?')
                .then(async value => {
                    if (value) {
                        message.status = 'READ'
                        await this.$api.updateItem(this, 'message', message)
                        this.$refs.trashTable.refresh()
                        this.$refs.inboxTable.refresh()
                    }
                })
        },
        refresh () {
            this.$refs.inboxTable.refresh()
            this.$refs.sentTable.refresh()
            this.$refs.draftsTable.refresh()
            this.$refs.trashTable.refresh()
        }
    },
})
</script>

<style lang="scss">
    .message-view > div {
        max-width: 1440px;
        margin: 0 auto;
    }
</style>